import React, {useContext} from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {FilterContext} from "../../layouts/SidePanelLayout";
import TradeBreaksPanelOriginal from "./TradeBreaksPanelOriginal";
import TradeBreaksPanel from "./TradeBreaksPanel";

export default function TradeBreaksPanelWrapper() {
    const {open} = useContext(FilterContext);

    function currentComponent() {
        if(open) {
            return <TradeBreaksPanel/>;
        }
        else  {
            return <TradeBreaksPanelOriginal/>;
        }
    }

    return(<>
        <Container fluid>
            <Row>
                <Col style={{padding:0}} >
                    {currentComponent()}
                </Col>
            </Row>
            <Row>
                <br/>
            </Row>
        </Container>
    </>);
}
